import React, { Fragment, useState } from "react"
import { Card, Row, Col, Button } from "react-bootstrap"
import { Link } from "react-router-dom"
import {
	faBusinessTime,
	faChartBar,
	faClipboardList,
	faPersonBooth,
	faBoxes,
	faUsers
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "./styles.css"
import {  getDateWithHour } from "../../utils"
import ModalCandidatos from "./ModalCandidatos"
import Loader from "./../shared/Loader"

const CardTricel = props => {
	const { votaciones, confirmaCierre, confirmaApertura, loaderApertura } = props
	const [showCandidatos, setShowCandidatos] = useState(false)
	const [votacionSelected, setVotacionSelected] = useState({})

	const openModalCandidatos = (votacion) => {
		setVotacionSelected(votacion)
		setShowCandidatos(true)
	}
	

	const estadoProceso = estado => {
		let icon = faBusinessTime
		let color = "warning"
		let text = "En Definición"
		switch (estado) {
			case "definicion":
				break
			case "abierto":
				icon = faPersonBooth
				color = "success"
				text = "Proceso Abierto"
				break
			case "cerrado":
				icon = faBoxes
				color = "danger"
				text = "Proceso Finalizado"
				break
			default:
				break
		}

		return (
			<Fragment>
				<FontAwesomeIcon icon={icon} size="5x" className={`text-${color} mb-4`} /> <br />
				<span className="statusSpan">{text}</span>
			</Fragment>
		)
	}

	const generateCards = () => {
		return votaciones.map((votacion, i )=> {
			return (
				<Fragment key={i}>
					<Card className="mb-4">
						<Card.Body className="tricelCardBody">
							<Row className="no-gutters">
								<Col lg={3} className="statusCol">
									{estadoProceso(votacion?.estado)}
								</Col>
								<Col lg="9" className="colInfoCard">
									<Row>
										<Col>
											<span className="titlePeriodo">
												Proceso: <b>{votacion?.nombre}</b>
											</span>
											<br />
											<span className="titleUnidad">
												Unidad: <b>{votacion?.unidad?.nombre}</b>
											</span>
										</Col>
									</Row>
									<Row>
										<Col className="my-auto">
											Desde {getDateWithHour(votacion?.desde)} <br />
											Hasta {getDateWithHour(votacion?.hasta)}
										</Col>
									</Row>
									<Row className="my-4">
										<Col className="text-center">
											<Link
												to={{ pathname: "/resultados", votacion: votacion }}
												className="btn btn-outline-info w-75"
											>
												<FontAwesomeIcon icon={faChartBar} size="3x" /> <br />
												Resultados
											</Link>
										</Col>
										<Col className="text-center">
											<Link
												to={{ pathname: "/padron", votacion: votacion }}
												className="btn btn-outline-info w-75"
											>
												<FontAwesomeIcon icon={faClipboardList} size="3x" /> <br />
												Padrón Electoral
											</Link>
										</Col>
										<Col className="text-center">
											<span
												className="btn btn-outline-info w-75"
												onClick={() => openModalCandidatos(votacion)}
											>
												<FontAwesomeIcon icon={faUsers} size="3x" /> <br />
												Candidatos
											</span>
										</Col>
									</Row>
								</Col>
							</Row>
							<Row className="no-gutters">
								<Col className="text-center colFooter">
									{loaderApertura ? (
										<Loader />
									) : (
										<Fragment>
											{votacion.estado === "abierto" && (
												<Button
													size="lg"
													className="w-25"
													variant="danger"
													onClick={() => confirmaCierre(votacion)}
												>
													FINALIZAR PROCESO
												</Button>
											)}
											{votacion.estado === "definicion" && (
												<Button
													size="lg"
													className="w-25"
													variant="success"
													onClick={() => confirmaApertura(votacion)}
												>
													INICIAR PROCESO
												</Button>
											)}
											{votacion.estado === "cerrado" && (
												<Button size="lg" className="w-25" variant="secondary" disabled>
													PROCESO FINALIZADO
												</Button>
											)}
											
										</Fragment>
									)}
								</Col>
							</Row>
						</Card.Body>
					</Card>
					<hr className="my-5" />
				</Fragment>
			)
		})
	}

	return <Fragment>
		{generateCards()}
		<ModalCandidatos
			setShow={setShowCandidatos}
			show={showCandidatos}
			votacion={votacionSelected}
		/>
		</Fragment>
}

export default CardTricel
